import {JSX} from "react/jsx-runtime";
import {Link} from "@/components/Link/Link.tsx";

export const renderWithHtml = (text: string | null | undefined) => {
  if (!text) {
    return null;
  }

  // Разбиваем по ссылкам
  const parts = text.split(/(https?:\/\/[^\s]+)/);

  const elements: (string | JSX.Element)[] = [];

  parts.forEach((part, i) => {
    if (part.match(/^https?:\/\//)) {
      // ссылка
      elements.push(
        <Link key={'link' + i} to={part}>
          {part}
        </Link>
      );
    } else {
      // обычный текст — разбиваем по \n и добавляем <br />
      const lines = part.split('\n');
      lines.forEach((line, j) => {
        elements.push(line);
        if (j < lines.length - 1) {
          elements.push(<br key={`br-${i}-${j}`} />);
        }
      });
    }
  });

  return elements;
};